import React,{ useContext, useEffect, useState, useRef } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { AppContext } from "../../App"
import { Button, Typography } from '@mui/material';
import { useReactToPrint } from 'react-to-print'

export default function Contract(){


  const { eventDetails, artistInfo } = useContext(AppContext)

  const printComponentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  })

  const [rows, setRows] = useState(eventDetails.contract)

  const openingPar = eventDetails.contractOpenPar.replace("<promoter>", eventDetails.promoterDetails.promoterName).replace("<band>", eventDetails.bandName).replace("<event>", eventDetails.eventDetails.eventName)

  console.log(artistInfo)

  return (
    <div className="event-details">
      <h3 className="section-title">
            Contract Review
      </h3>
      <Paper elevation={3} ref={printComponentRef}>
        <img src={require("../../contract.png")} alt="contract-logo" className='contract-logo' />
        <Typography className="confidential-clause">{openingPar}</Typography>
        <TableContainer >
          <Table>
            <TableBody>
              <TableRow>
                  <TableCell className="clause-header">Performer</TableCell>
                  <TableCell>{eventDetails.bandName}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Event Name</TableCell>
                  <TableCell>{eventDetails.eventDetails.eventName}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Event Date</TableCell>
                  <TableCell>{eventDetails.eventDetails.eventDate}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Venue</TableCell>
                  <TableCell>{eventDetails.eventDetails.venueName}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Performance Time</TableCell>
                  <TableCell>{eventDetails.eventDetails.performTime}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Performance Duration</TableCell>
                  <TableCell>{eventDetails.eventDetails.performDuration}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Soundcheck Time</TableCell>
                  <TableCell>{eventDetails.eventDetails.soundcheckTime}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Performance Fee</TableCell>
                  <TableCell>{eventDetails.eventDetails.performFee}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Additional Fee(s)</TableCell>
                  <TableCell>{eventDetails.eventDetails.addFee}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Payment Terms</TableCell>
                  <TableCell>{eventDetails.eventDetails.payTerms}</TableCell>
              </TableRow>
              {rows.map((row) => (
                <TableRow>
                  <TableCell className="clause-header">{row.heading}</TableCell>
                  <TableCell>{row.content}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                  <TableCell className="clause-header">Promoter Rep Name</TableCell>
                  <TableCell>_____________ on Behalf of {eventDetails.promoterDetails.promoterName}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Promoter Contact Number</TableCell>
                  <TableCell>{eventDetails.promoterDetails.companyContactNo}</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Promoter Address</TableCell>
                  <TableCell>{eventDetails.promoterDetails.promoterAddress}</TableCell>
              </TableRow>
              <TableRow sx={{height: 100}}>
                  <TableCell className="clause-header">Promoter Signature</TableCell>
                  <TableCell></TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Date of Signature</TableCell>
                  <TableCell>Signed at _______________ on this the ___ day of ___________________ 20___</TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Band Rep Name</TableCell>
                  <TableCell>{eventDetails.bandDetails.person} on behalf of {eventDetails.bandName} </TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Band Email</TableCell>
                  <TableCell>{eventDetails.bandDetails.email}</TableCell>
              </TableRow>
              <TableRow sx={{height: 100}}>
                  <TableCell className="clause-header">Band Signature</TableCell>
                  <TableCell></TableCell>
              </TableRow>
              <TableRow>
                  <TableCell className="clause-header">Date of Signature</TableCell>
                  <TableCell>Signed at _______________ on this the ___ day of ___________________ 20___</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </ TableContainer>

      </Paper>
      <Button onClick={handlePrint}>Print</Button>
    </div>
  )
}
